// extracted by mini-css-extract-plugin
export default {"container":"player_container__3STs9","icon-button":"player_icon-button__qK34h","toggle":"player_toggle__gwA+q"};